/**
 * Visual assets for /foretag premium redesign.
 * Sources: live `event_images` (Festutrustning productions) — never stock.
 */
export const FORETAG_HERO_IMAGE = {
  /** Awards på Boozt HQ Malmö — corporate B2B production */
  src: 'https://vibncjluhzsuhymwumdt.supabase.co/storage/v1/object/public/products/event-images/1766475896761-4q7qzfdjpyi.jpeg',
  alt: 'Awards-produktion på Boozt HQ i Malmö – scen, ljus och ljud från festutrustning.se',
  caption: 'Awards på Boozt HQ Malmö',
  width: 1824,
  height: 1368,
} as const;

/** Scen + DJ-rigg med tross och moving heads — /julfest-foretag. */
export const JULFEST_FORETAG_HERO_IMAGE = {
  src: '/company/julfest-foretag-scen.jpg',
  alt: 'Professionell scen med DJ-bås, tross, moving heads och PA – teknik till företagsjulfest från festutrustning.se',
  caption: 'Scen, ljus & ljud till företagsfest',
  width: 1024,
  height: 767,
} as const;

/** Short visual labels for timeline (Phase 2A step titles/bodies unchanged). */
export const FORETAG_JOURNEY_SHORT_LABELS = [
  'Behov',
  'Lösning',
  'Offert',
  'Leverans & rigg',
  'Genomförande',
  'Rivning',
] as const;
